import { BaseResource } from '@/models/_base.model';
import { Account } from '@/models/account.model';
import { User } from '@/models/user.model';

export enum CouponScopeEnum {
  GLOBAL = 'global',
  ACCOUNT = 'account'
}

export enum CouponTypeEnum {
  PERCENTAGE_OFF_CARE_PLAN = 'percentage_off_care_plan',
  AMOUNT_OFF_CARE_PLAN = 'amount_off_care_plan',
  PERCENTAGE_OFF_INVOICE = 'percentage_off_invoice',
  AMOUNT_OFF_INVOICE = 'amount_off_invoice',
  OTHER = 'other'
}

export type CouponFlat = BaseResource & {
  code: string;
  description: string | null;
  scope: CouponScopeEnum;
  accountId: string | null;
  authorId: string;
  amountOff: number | null;
  percentageOff: number | null;
  couponType: CouponTypeEnum;
  isFreeShipping: boolean;
  isActive: boolean;
};

export type Coupon = CouponFlat & {
  account: Account | null;
  author: User;
};

export type CreateCouponDto = {
  code: string;
  description: string | null;
  scope: CouponScopeEnum;
  accountId: string | null;
  authorId: string;
  isForCarePlanOnly: boolean;
  isFreeShipping: boolean;
  amountOff: number | null;
  percentageOff: number | null;
  isActive: boolean;
};

export type UpdateCouponDto = Partial<{
  description: string | null;
  isActive: boolean;
}>;
